<template>
  <div class="main-wrapper authendication-pages">
    <div class="content blur-ellipses login-password">
      <div class="container">
        <div class="row">
          <div
            class="col-xl-6 col-lg-6 col-md-7 mx-auto vph-100 d-flex align-items-center"
          >
            <div class="change-password w-100">
              <header class="text-center">
                <router-link to="/">
                  <img src="@/assets/img/logo_red.png" class="img-fluid" alt="Logo" />
                </router-link>
              </header>
              <div class="shadow-card">
                <h2>Đổi mật khẩu</h2>
                <p>
                  Mật khẩu mới của bạn phải khác với
                  mật khẩu trước đó bạn sử dụng
                </p>
                <!-- Login Form -->
                <form>
                  <div class="form-group">
                    <div class="pass-group group-img">
                      <i class="toggle-password feather-eye"></i>
                      <input
                        type="password"
                        class="form-control pass-input"
                        placeholder="Mật khẩu mới"
                      />
                    </div>
                  </div>
                  <div class="form-group">
                    <div class="pass-group group-img">
                      <i class="toggle-password-confirm feather-eye"></i>
                      <input
                        type="password"
                        class="form-control pass-confirm"
                        placeholder="Xác nhận mật khẩu "
                      />
                    </div>
                  </div>
                  <router-link
                    to="/"
                    class="btn btn-secondary w-100 d-inline-flex justify-content-center align-items-center"
                    >Đổi mật khẩu <i class="feather-arrow-right-circle ms-2"></i
                  ></router-link>
                </form>
                <!-- /Login Form -->
              </div>
              <div class="bottom-text text-center">
                <p>Đã có tài khoản? <router-link to="/">Đăng nhập!</router-link></p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
